/* eslint-disable no-unused-vars */
import React from "react";
import {Container, Typography} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {TextDecrypt} from "../content/TextDecrypt";
import {FirstName, LastName} from "../../utils/getName";

import './About.css';

import profile from '../../assets/profile.png';

const useStyles = makeStyles((theme) => ({
    main: {
        maxWidth: '100vw',
        marginTop: '3em',
        marginBottom: "auto",
    },
}));

export const About = () => {
    const classes = useStyles();
    const greetings = "Hello there!";
    const aboutme = `My name is ${FirstName} ${LastName} and I am a web developer with a passion for creating innovative and engaging digital experiences.
    My interest in web development began in high school and has remained a driving force in my life ever since. 
    As a creative problem-solver, I am constantly seeking new challenges and opportunities to grow my skills and create something truly remarkable.
    I am always eager to take on new projects and push the boundaries of what is possible online.`;

    return (
        <section id="about">
            <Container component="main" className={classes.main} maxWidth="md">
                <div className="about">
                    <div className="_img"
                         style={{
                             backdropFilter: "blur(5px)",
                             background: "url(" + profile + ")",
                             backgroundSize: 'contain',
                             backgroundPosition: 'center',
                             backgroundRepeat: 'no-repeat',
                             // height:"280px"
                         }}
                    >
                    </div>
                    <div className="_content_wrapper">
                        <Typography component='h2' variant="h5">
                            <TextDecrypt text={`${greetings}`}/>
                        </Typography>
                        <p className="aboutme">
                            {aboutme}
                        </p>
                        <a href="#contact" className="contact-btn">
                            <i className="fas fa-terminal"></i>
                            <Typography component='span'> Send me a message.</Typography>
                        </a>
                    </div>
                </div>
            </Container>
        </section>
    );
};
